import { products, type Product } from "@/lib/products";

export type PromoCartItem = { slug: string; quantity: number };

export const BUNDLE_CODE = "4AL3ODE";
/** 4 Al 3 Öde'ye dahil kategoriler (ad içinde aranır). */
const BUNDLE_KEYWORDS = ["tırnak", "tirnak", "protez", "oje", "french", "manikür", "manikur"];

const norm = (s: string) =>
  s.toLocaleLowerCase("tr").replace(/-/g, " ").replace(/ı/g, "i").replace(/ş/g, "s").replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ö/g, "o").replace(/ç/g, "c");

function isBundleEligible(name: string, category: string, slug: string): boolean {
  const hay = norm(`${name} ${category} ${slug}`);
  return BUNDLE_KEYWORDS.some((k) => hay.includes(k));
}

export type BundleResult = {
  /** Bedava kazanılan birim sayısı (4 Al 3 Öde) */
  freeCount: number;
  /** 4 Al 3 Öde indirimi (₺) */
  bundleDiscount: number;
  /** 2. ürün %30'dan indirimli birim sayısı */
  secondCount: number;
  /** 2. ürün %30 indirimi (₺) */
  secondDiscount: number;
  /** Toplam promosyon indirimi (₺) */
  discount: number;
  /** Bir sonraki bedava için kalan ürün sayısı (0 = eşikte) */
  remaining: number;
  /** Bir sonraki %30 için kalan ürün sayısı */
  secondRemaining: number;
  /** Kampanyaya dahil toplam birim */
  eligibleQty: number;
};

const round2 = (n: number) => Math.round(n * 100) / 100;

/**
 * Sepet promosyonları — otomatik, kod gerekmez.
 * 1) 4 Al 3 Öde: dahil ürünlerde her 4 birimde en ucuz birim bedava.
 * 2) 2. Ürün %30: bedavalar düşüldükten sonra kalan TÜM ürünlerde her
 *    çiftin ucuzu %30 indirimli (pahalıdan ucuza sırala, 2./4./6. birimler).
 */
export type CatalogLike = Pick<Product, "slug" | "name" | "price" | "category" | "inStock">;

export function calcBundle(items: PromoCartItem[], catalog: CatalogLike[] = products): BundleResult {
  const eligible: number[] = [];
  const all: number[] = [];
  for (const it of items) {
    const item = catalog.find((p) => p.slug === it.slug);
    if (!item) continue;
    if (!item.inStock) continue;
    // IB5: fiyatı 0 olan ürünler promosyon havuzuna girmez (sayaç kirlenmez)
    if (!(item.price > 0)) continue;
    const qty = Math.max(0, Math.min(99, Math.floor(it.quantity) || 0));
    for (let i = 0; i < qty; i++) {
      all.push(item.price);
      if (isBundleEligible(item.name, item.category, item.slug)) eligible.push(item.price);
    }
  }

  // Adım 1: 4 Al 3 Öde (en ucuzlar bedava)
  eligible.sort((a, b) => a - b);
  const freeCount = Math.floor(eligible.length / 4);
  const bundleDiscount = round2(eligible.slice(0, freeCount).reduce((s, p) => s + p, 0));
  const remaining = eligible.length === 0 ? 4 : (4 - (eligible.length % 4)) % 4;

  // Bedava birimleri toplam havuzdan düş (en ucuz eşleşenler)
  const freeValues = eligible.slice(0, freeCount);
  const rest = [...all].sort((a, b) => a - b);
  for (const v of freeValues) {
    const idx = rest.indexOf(v);
    if (idx !== -1) rest.splice(idx, 1);
  }

  // Adım 2: 2. ürün %30 (pahalıdan sırala, her çiftin 2.si)
  rest.sort((a, b) => b - a);
  let secondDiscount = 0;
  let secondCount = 0;
  for (let i = 1; i < rest.length; i += 2) {
    secondDiscount += rest[i] * 0.3;
    secondCount += 1;
  }
  secondDiscount = round2(secondDiscount);
  const secondRemaining = rest.length === 0 ? 0 : (2 - (rest.length % 2)) % 2;

  return {
    freeCount,
    bundleDiscount,
    secondCount,
    secondDiscount,
    discount: round2(bundleDiscount + secondDiscount),
    remaining,
    secondRemaining,
    eligibleQty: eligible.length,
  };
}
